<template>
  <div class="brand-keypoint-component">
    <div class="brand-section app-basic-layout-wrapper">
      <h3 class="title font-30">品牌营销痛点</h3>
      <p class="subtitle font-color-desc">互动营销新途径，激活潜在兴趣人群</p>
      <div class="body">
        <div class="image-wrapper">
          <img src="@/assets/img/brand/wenti1.png" />
        </div>
        <div class="image-wrapper">
          <img src="@/assets/img/brand/wenti2.png" />
        </div>
        <div class="image-wrapper">
          <img src="@/assets/img/brand/wenti3.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.brand-keypoint-component {
  background-color: #f4f5f7;
}
.body {
  display: flex;
  justify-content: space-between;
  padding-top: 60px;
  box-sizing: border-box;
  .image-wrapper {
    width: 373px;
    height: 270px;
    overflow: hidden;
    border-radius: 8px;
    img {
      width: 100%;
      height: 100%;
      float: left;
      object-fit: cover;
    }
  }
}
</style>
